/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';
import { code, data } from './playground';

const page: {
  root: Item<'Page'>;
  d3Chart: Item<'D3Chart'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  showMessage: Item<'ActionShowMessage'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  dataAliasLocalDataStore: Item<'LocalDataStore'>;
  dataAliasDataStoreReference: Item<'DataStoreReference'>;
} = {
  d3Chart: {
    children: ['triggerOnClick'],
    itemId: 'd3Chart',
    parent: 'dataAliasDataStoreReference',
    props: { d3Script: '' },
    type: 'D3Chart',
  },
  dataAliasDataStoreReference: {
    children: ['d3Chart'],
    itemId: 'dataAliasDataStoreReference',
    parent: 'flexItem',
    props: {
      alias: 'dataAlias',
    },
    type: 'DataStoreReference',
  },
  dataAliasLocalDataStore: {
    children: [],
    itemId: 'dataAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'dataAlias',
      dataFormat: 'json',
      dataSource: 'data',
      jsonData: JSON.stringify(data, null, 2),
    },
    type: 'LocalDataStore',
  },
  flexItem: {
    children: ['dataAliasDataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  root: {
    children: ['dataAliasLocalDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'D3 Chart',
      },
    },
    type: 'Page',
  },
  showMessage: {
    children: [],
    itemId: 'showMessage',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'expression',
        value:
          '`Date: ${$._.record?.date}, Temperature: ${$._.record?.temperature}`',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  triggerOnClick: {
    children: ['showMessage'],
    itemId: 'triggerOnClick',
    parent: 'd3Chart',
    props: {},
    type: 'TriggerOnClick',
  },
};

export const helpRenders: ComponentSample<'D3Chart'>[] = [
  {
    title: 'Sample D3 Chart',
    description: `Check the D3 Script property for the code used to render this chart

You can use the below project to create the D3 chart locally and then copy the code from playground.tsx to the D3 Script property.

[https://github.com/cloudio-saas/d3](https://github.com/cloudio-saas/d3)
`,
    page,
    exampleId: 'eg-01GKXAKF0P5PHCNZDEEWKPS3WB',
    clearParentChildren: true,
    height: 480,
    visibleProps: ['d3Script'],
    item: {
      type: 'D3Chart',
      props: {
        d3Script: code,
      },
      itemId: 'd3Chart',
      parent: 'dataAliasDataStoreReference',
      children: ['triggerOnClick'],
    },
  },
];
